import { PageTitle } from '@supplement-bacon/react-toolkit/components'
import {
  App,
  Button,
  Card,
  Flex,
  Form,
  InputNumber,
  Space,
  Typography,
} from 'antd'
import { FC, useEffect, useState } from 'react'
import { DEFAULT_ERROR, DEFAULT_SUCCESS } from '../../App'
import { updateReferralCreditsForUser } from '../../services/UserService'
import { useAppSelector } from '../../store/hooks'
import { selectUserById } from '../../store/UserReducer'
import { Permission } from '../../utils/permissions'
import { numberRule, requiredRule } from '../../utils/rules'
import HasAccess, { useHasAccess } from '../HasAccess'
import { LoyaltyReferredUsers } from './LoyaltyReferredUsers'

const { Text } = Typography
interface Props {
  userId: number
}

const LoyaltyReferral: FC<Props> = ({ userId }) => {
  const [form] = Form.useForm()
  const { message } = App.useApp()
  const user = useAppSelector(selectUserById(userId))
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { hasAccess } = useHasAccess()

  const onCreditsFormFinish = (values: { referralCredits: number }) => {
    setIsLoading(true)
    updateReferralCreditsForUser(userId, values.referralCredits)
      .then(() => {
        message.success(DEFAULT_SUCCESS)
      })
      .catch(() => {
        message.error(DEFAULT_ERROR)
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    form.setFieldsValue(user)
  }, [user])

  return (
    <Space orientation="vertical" className="w-full" size={8}>
      <PageTitle level={5} title={'Referral'} style={{ margin: 0 }} />
      <Card loading={!user}>
        <Flex vertical gap={10}>
          <Form
            form={form}
            layout="horizontal"
            onFinish={onCreditsFormFinish}
            disabled={isLoading}
            style={{ width: '100%' }}
          >
            <Space orientation="vertical" className="w-full">
              <Text>Referral credits</Text>
              <Space.Compact className="w-full">
                <Form.Item
                  className="w-full"
                  name={'referralCredits'}
                  rules={[requiredRule(), numberRule()]}
                >
                  <InputNumber
                    min={0}
                    className="w-full"
                    disabled={!hasAccess(Permission.addCreditsReferral)}
                  />
                </Form.Item>
                <HasAccess permissions={[Permission.addCreditsReferral]}>
                  <Button
                    loading={isLoading}
                    disabled={isLoading}
                    type="primary"
                    htmlType="submit"
                  >
                    Save
                  </Button>
                </HasAccess>
              </Space.Compact>
            </Space>
          </Form>

          <LoyaltyReferredUsers userId={user!.id} />
        </Flex>
      </Card>
    </Space>
  )
}

type LoyaltyReferralType = { LoyaltyReferral: typeof LoyaltyReferral }

export { LoyaltyReferral, type LoyaltyReferralType }
